module.exports = __webpack_public_path__ + "img/kenya.d35eb79a.svg";